import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    trendUp: {
        fill: theme.palette.error.main,
        transform: "scale(0.7) translate(15px, -13px)",
    },
    trendDown: {
        fill: theme.palette.success.main,
        transform: "scale(0.7) rotate(180deg) translate(-38px, -12px)",
    },
    trendSame: {
        fill: `${theme.palette.warning.main} !important`,
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: theme.spacing(1),
        },
    },
    text: { fontSize: "10px", fontFamily: "Open Sans" },
}));
